const dangerFieldset = {
    colorScheme: {
        light: {
            border: {
                color: '{red.500}'
            },
            legend: {
                border: {
                    color: '{red.500}'
                }
            }
        },
        dark: {
            border: {
                color: '{red.400}'
            },
            legend: {
                border: {
                    color: '{red.400}'
                }
            }
        }
    }
};

export default dangerFieldset;
